// DATE es día de calendario; TIMESTAMPTZ es un instante. No convertir DATE con new Date().
export const ZONA_OPERATIVA = 'America/Guatemala';
const FECHA_RE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const partesGT = new Intl.DateTimeFormat('en-US', {
  timeZone: ZONA_OPERATIVA, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});
export const fechaCalendario = (valor) => {
  if (typeof valor !== 'string' || !FECHA_RE.test(valor)) return null;
  const [y, m, d] = valor.split('-').map(Number);
  const t = new Date(Date.UTC(y, m - 1, d));
  return t.getUTCFullYear() === y && t.getUTCMonth() === m - 1 && t.getUTCDate() === d ? valor : null;
};
const partes = (instante) => {
  const d = instante instanceof Date ? instante : new Date(instante);
  if (!Number.isFinite(d.getTime())) throw new TypeError('Timestamp inválido');
  return Object.fromEntries(partesGT.formatToParts(d).map(({ type, value }) => [type, value]));
};
export const fechaGT = (instante = new Date()) => {
  const p = partes(instante);
  return `${p.year}-${p.month}-${p.day}`;
};
export const todayISO = () => fechaGT();
export const getTodayLocalISO = todayISO;
export const formatDate = (fecha) => {
  if (!fechaCalendario(fecha)) return '—';
  const [y, m, d] = fecha.split('-');
  return `${d}/${m}/${y}`;
};
export const formatDateTime = (instante) => {
  if (!instante) return '—';
  const p = partes(instante);
  return `${p.day}/${p.month}/${p.year}, ${p.hour}:${p.minute}`;
};
export const formatTime = (instante) => {
  if (!instante) return '—';
  const p = partes(instante);
  return `${p.hour}:${p.minute}`;
};
export const dateTimeLocalGT = (instante = new Date()) => {
  const p = partes(instante);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};
export const parseDateTimeLocalGT = (valor) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(String(valor || ''));
  if (!m || !fechaCalendario(m[0].slice(0, 10)) || Number(m[4]) > 23 || Number(m[5]) > 59) return null;
  const [y, mes, dia, hora, minuto] = m.slice(1).map(Number);
  const supuestoUTC = Date.UTC(y, mes - 1, dia, hora, minuto);
  const p = partes(new Date(supuestoUTC));
  const vistoComoUTC = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute));
  const instante = new Date(supuestoUTC - (vistoComoUTC - supuestoUTC));
  return dateTimeLocalGT(instante) === valor ? instante.toISOString() : null;
};
export const sumarDiasCalendario = (fecha, dias) => {
  if (!fechaCalendario(fecha) || !Number.isInteger(dias)) throw new TypeError('Fecha o días inválidos');
  const [y, m, d] = fecha.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + dias)).toISOString().slice(0, 10);
};
export const sumarMesesCalendario = (fecha, meses) => {
  if (!fechaCalendario(fecha) || !Number.isInteger(meses)) throw new TypeError('Fecha o meses inválidos');
  const [y, m, d] = fecha.split('-').map(Number);
  const total = y * 12 + m - 1 + meses;
  const yy = Math.floor(total / 12), mm = total % 12;
  const ultimo = new Date(Date.UTC(yy, mm + 1, 0)).getUTCDate();
  return new Date(Date.UTC(yy, mm, Math.min(d, ultimo))).toISOString().slice(0, 10);
};
export const finDeMes = (mes) => {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(mes)) throw new TypeError('Mes inválido');
  const [y, m] = mes.split('-').map(Number);
  return new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10);
};
